"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var SubmitButton_1 = require("./SubmitButton");
var i18n_1 = require("@wordpress/i18n");
function StudyAbroadDetails(props) {
    var tripTypeId = props.tripTypeId;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "trip_type_id", value: tripTypeId }), (0, jsx_runtime_1.jsx)("div", { class: "appform-destination-details", dangerouslySetInnerHTML: { __html: window.appformStudyAbroadDescription || '' } }), (0, jsx_runtime_1.jsx)("div", __assign({ class: "appform-buttons-group" }, { children: (0, jsx_runtime_1.jsx)(SubmitButton_1.default, { label: (0, i18n_1.__)("Continue", "projects-abroad"), value: "continue" }) }))] }));
}
exports.default = StudyAbroadDetails;
